import { CONSTANTS } from "./callcentral.constants";

export const menuSettingsConstants = [
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.MY_PROFILE,
    menuName: "myProfile",
    menuIcon: "icon-profile",
    menuCode: "My Profile",
    isMenuSelected: false,
    link: "/client/my-profile",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.SETTINGS,
    menuName: "settings",
    menuIcon: "icon-settings",
    menuCode: "Settings",
    isMenuSelected: false,
    link: "/client/settings",
  },

  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.AVAILABILITY_LIST,
    menuName: "availabilityList",
    menuIcon: "icon-availability_list",
    menuCode: "Availability List",
    isMenuSelected: false,
    link: "/client/availability-list",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.MY_CONTACT_NUMBER,
    menuName: "myContactNumber",
    menuIcon: "icon-contact",
    menuCode: "My Contact Number",
    isMenuSelected: false,
    link: "/client/my-contact-number",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.SCHEDULE_SYNC,
    menuName: "scheduleSync",
    menuIcon: "icon-sync1",
    menuCode: "Schedule Sync",
    isMenuSelected: false,
    link: "/client/schedule-sync",
  },

  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.HELP,
    menuName: "help",
    menuIcon: "icon-help",
    menuCode: "Help",
    isMenuSelected: false,
    link: "/client/help",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.ABOUT_US,
    menuName: "aboutUs",
    // menuIcon: "icon-about_us",
    menuIcon: "icon-About_us",
    menuCode: "About Us",
    isMenuSelected: false,
    link: "/client/about-us",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.LOG_OUT,
    menuName: "signOff",
    menuIcon: "icon-logout",
    menuCode: "Sign Off",
    isMenuSelected: false,
  },
];

export const ONmenuSettingsConstants = [
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.MY_PROFILE,
    menuName: "myProfile",
    menuIcon: "icon-profile",
    menuCode: "My Profile",
    isMenuSelected: false,
    link: "/client/my-profile",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.SETTINGS,
    menuName: "settings",
    menuIcon: "icon-settings",
    menuCode: "Settings",
    isMenuSelected: false,
    link: "/client/settings",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.MY_CONTACT_NUMBER,
    menuName: "myContactNumber",
    menuIcon: "icon-contact",
    menuCode: "My Contact Number",
    isMenuSelected: false,
    link: "/client/my-contact-number",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.HELP,
    menuName: "help",
    menuIcon: "icon-help",
    menuCode: "Help",
    isMenuSelected: false,
    link: "/client/help",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.ABOUT_US,
    menuName: "aboutUs",
    // menuIcon: "icon-about_us",
    menuIcon: "icon-About_us",
    menuCode: "About Us",
    isMenuSelected: false,
    link: "/client/about-us",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.LOG_OUT,
    menuName: "signOff",
    menuIcon: "icon-logout",
    menuCode: "Sign Off",
    isMenuSelected: false,
  },
];

export const emsMenuSettingsConstants = [
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.MY_PROFILE,
    menuName: "myProfile",
    menuIcon: "icon-profile",
    menuCode: "My Profile",
    isMenuSelected: false,
    link: "/client/my-profile",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.SETTINGS,
    menuName: "settings",
    menuIcon: "icon-settings",
    menuCode: "Settings",
    isMenuSelected: false,
    link: "/client/settings",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.MY_CONTACT_NUMBER,
    menuName: "myContactNumber",
    menuIcon: "icon-contact",
    menuCode: "My Contact Number",
    isMenuSelected: false,
    link: "/client/my-contact-number",
  },

  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.HELP,
    menuName: "help",
    menuIcon: "icon-help",
    menuCode: "Help",
    isMenuSelected: false,
    link: "/client/help",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.ABOUT_US,
    menuName: "aboutUs",
    // menuIcon: "icon-about_us",
    menuIcon: "icon-About_us",
    menuCode: "About Us",
    isMenuSelected: false,
    link: "/client/about-us",
  },
  {
    menuId: CONSTANTS.MENU_SETTINGS_LIST_ITEMS.LOG_OUT,
    menuName: "signOff",
    menuIcon: "icon-logout",
    menuCode: "Sign Off",
    isMenuSelected: false,
  },
];
